import { render } from "./GamesView.vue?vue&type=template&id=88eeffa0"
import script from "./GamesView.vue?vue&type=script&lang=js"
export * from "./GamesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__